<template>
  <div id="supplier-page">
      <Header></Header>
      <SuppliersTable></SuppliersTable>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import SuppliersTable from "@/components/production-planning/SuppliersTable.vue";
export default {
    name: "supplier-page",
    components: {
        Header,
        SuppliersTable
    }
}
</script>

<style>

</style>